// src/components/Admin/AdminFilters.jsx - Con ricerca utente migliorata
import React, { useState, useEffect } from 'react';
import { getMonthName } from '../../utils/dateUtils';

const AdminFilters = ({ filters, setFilters, onFiltersChange, reports }) => {
  // Usa setFilters se disponibile, altrimenti onFiltersChange per retrocompatibilità
  const updateFilters = setFilters || onFiltersChange;

  const [availableMonths, setAvailableMonths] = useState([]);
  const [availableYears, setAvailableYears] = useState([]);
  const [availableUsers, setAvailableUsers] = useState([]);
  
  // Stato per ricerca utente
  const [userSearchTerm, setUserSearchTerm] = useState('');
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [showUserSuggestions, setShowUserSuggestions] = useState(false);

  // Estrai valori unici per i filtri dai dati - LOGICA CORRETTA
  useEffect(() => {
    if (reports && reports.length > 0) {
      console.log("AdminFilters: Elaborazione", reports.length, "segnalazioni");
      
      // Estrai mesi unici dalle date di creazione
      const months = new Set();
      const years = new Set();
      const usersData = new Map(); // Mappa per memorizzare dati completi utente

      reports.forEach(report => {
        try {
          // Gestione corretta delle date da Firestore
          let reportDate;
          
          if (report.createdAt) {
            if (report.createdAt.seconds) {
              reportDate = new Date(report.createdAt.seconds * 1000);
            } else if (report.createdAt instanceof Date) {
              reportDate = report.createdAt;
            } else if (typeof report.createdAt === 'string') {
              reportDate = new Date(report.createdAt);
            }
          }
          
          // Se abbiamo una data valida, estraiamo mese e anno
          if (reportDate && !isNaN(reportDate.getTime())) {
            months.add(reportDate.getMonth() + 1);
            years.add(reportDate.getFullYear());
          }
          
          // Raccogli informazioni utente complete
          if (report.userEmail) {
            const userKey = report.userEmail;
            const userData = {
              email: report.userEmail,
              nome: report.userName || '',
              cognome: report.userSurname || '',
              displayName: ''
            };
            
            // Crea il nome di visualizzazione
            if (userData.nome && userData.cognome) {
              userData.displayName = `${userData.nome} ${userData.cognome}`;
            } else if (report.userName && report.userName.includes(' ')) {
              // Se userName contiene nome e cognome insieme
              userData.displayName = report.userName;
            } else {
              userData.displayName = report.userEmail;
            }
            
            usersData.set(userKey, userData);
          }
          
        } catch (error) {
          console.warn("Errore nell'elaborazione della segnalazione:", report.id, error);
        }
      });

      // Converti Set in array e ordina
      const monthsArray = Array.from(months).sort((a, b) => a - b);
      const yearsArray = Array.from(years).sort((a, b) => b - a);
      const usersArray = Array.from(usersData.values()).sort((a, b) => 
        a.displayName.localeCompare(b.displayName)
      );

      console.log("AdminFilters: Mesi disponibili:", monthsArray);
      console.log("AdminFilters: Anni disponibili:", yearsArray);
      console.log("AdminFilters: Utenti disponibili:", usersArray.length);

      setAvailableMonths(monthsArray);
      setAvailableYears(yearsArray);
      setAvailableUsers(usersArray);
    } else {
      setAvailableMonths([]);
      setAvailableYears([]);
      setAvailableUsers([]);
    }
  }, [reports]);

  // Filtra gli utenti in base al termine di ricerca
  useEffect(() => {
    if (userSearchTerm.trim() === '') {
      setFilteredUsers([]);
      setShowUserSuggestions(false);
      return;
    }

    const searchTerm = userSearchTerm.toLowerCase();
    const filtered = availableUsers.filter(user => {
      return (
        user.displayName.toLowerCase().includes(searchTerm) ||
        user.email.toLowerCase().includes(searchTerm) ||
        (user.nome && user.nome.toLowerCase().includes(searchTerm)) ||
        (user.cognome && user.cognome.toLowerCase().includes(searchTerm))
      );
    });

    setFilteredUsers(filtered);
    setShowUserSuggestions(true);
  }, [userSearchTerm, availableUsers]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    console.log("AdminFilters: Cambio filtro", name, "->", value);
    
    if (updateFilters) {
      updateFilters(prev => ({ ...prev, [name]: value }));
    } else {
      console.error("AdminFilters: Nessuna funzione di aggiornamento filtri disponibile");
    }
  };

  // Gestisce la ricerca utente
  const handleUserSearchChange = (e) => {
    const value = e.target.value;
    setUserSearchTerm(value);
    
    // Se il campo viene svuotato, resetta il filtro utente
    if (value.trim() === '') {
      if (updateFilters) {
        updateFilters(prev => ({ ...prev, user: '' }));
      }
    }
  };

  // Gestisce la selezione di un utente dai suggerimenti
  const handleUserSelect = (user) => {
    setUserSearchTerm(user.displayName);
    setShowUserSuggestions(false);
    
    if (updateFilters) {
      // Usa l'email per il filtro effettivo
      updateFilters(prev => ({ ...prev, user: user.email }));
    }
  };

  // Gestisce il blur del campo ricerca utente
  const handleUserSearchBlur = () => {
    setTimeout(() => {
      setShowUserSuggestions(false);
    }, 200);
  };

  // Gestisce il focus del campo ricerca utente
  const handleUserSearchFocus = () => {
    if (userSearchTerm.trim() !== '' && filteredUsers.length > 0) {
      setShowUserSuggestions(true);
    }
  };

  const resetFilters = () => {
    console.log("AdminFilters: Reset filtri");
    
    if (updateFilters) {
      updateFilters({
        month: '',
        year: '',
        status: '',
        user: ''
      });
    }
    
    // Reset anche del campo di ricerca utente
    setUserSearchTerm('');
    setShowUserSuggestions(false);
  };

  // Inizializza il campo di ricerca con il filtro utente esistente
  useEffect(() => {
    if (filters.user && availableUsers.length > 0) {
      const selectedUser = availableUsers.find(user => user.email === filters.user);
      if (selectedUser && userSearchTerm !== selectedUser.displayName) {
        setUserSearchTerm(selectedUser.displayName);
      }
    } else if (!filters.user && userSearchTerm) {
      setUserSearchTerm('');
    }
  }, [filters.user, availableUsers]);

  return (
    <div className="admin-filters">
      <h3>Filtra Segnalazioni</h3>
      
      {/* Informazioni di debug in sviluppo */}
      {process.env.NODE_ENV === 'development' && (
        <div style={{ 
          background: '#f8f9fa', 
          padding: '10px', 
          marginBottom: '15px', 
          borderRadius: '4px',
          fontSize: '12px',
          color: '#666'
        }}>
          <strong>Debug Info:</strong> {reports?.length || 0} segnalazioni, 
          {availableMonths.length} mesi, {availableYears.length} anni, {availableUsers.length} utenti
        </div>
      )}
      
      <div className="filters-container">
        <div className="filter-group">
          <label htmlFor="month-filter">Mese:</label>
          <select
            id="month-filter"
            name="month"
            value={filters.month}
            onChange={handleFilterChange}
          >
            <option value="">Tutti i mesi</option>
            {availableMonths.map(month => (
              <option key={month} value={month}>
                {getMonthName(month)}
              </option>
            ))}
          </select>
        </div>

        <div className="filter-group">
          <label htmlFor="year-filter">Anno:</label>
          <select
            id="year-filter"
            name="year"
            value={filters.year}
            onChange={handleFilterChange}
          >
            <option value="">Tutti gli anni</option>
            {availableYears.map(year => (
              <option key={year} value={year}>{year}</option>
            ))}
          </select>
        </div>

        <div className="filter-group">
          <label htmlFor="status-filter">Stato:</label>
          <select
            id="status-filter"
            name="status"
            value={filters.status}
            onChange={handleFilterChange}
          >
            <option value="">Tutti gli stati</option>
            <option value="In attesa">In attesa</option>
            <option value="Presa in carico">Presa in carico</option>
            <option value="Conclusa">Conclusa</option>
          </select>
        </div>

        {/* NUOVO: Campo di ricerca utente con autocompletamento */}
        <div className="filter-group" style={{ position: 'relative' }}>
          <label htmlFor="user-search">Cerca Utente o lascia vuoto:</label>
          <input
            id="user-search"
            type="text"
            value={userSearchTerm}
            onChange={handleUserSearchChange}
            onFocus={handleUserSearchFocus}
            onBlur={handleUserSearchBlur}
            placeholder="Digita nome, cognome o email..."
            className="form-control"
            style={{ width: '100%' }}
          />
          
          {/* Lista suggerimenti utenti */}
          {showUserSuggestions && filteredUsers.length > 0 && (
            <div className="user-suggestions-dropdown" style={{
              position: 'absolute',
              top: '100%',
              left: 0,
              right: 0,
              backgroundColor: 'white',
              border: '1px solid #ccc',
              borderTop: 'none',
              borderRadius: '0 0 4px 4px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              zIndex: 1000,
              maxHeight: '200px',
              overflowY: 'auto'
            }}>
              {filteredUsers.map((user, index) => (
                <div
                  key={index}
                  className="user-suggestion-item"
                  onClick={() => handleUserSelect(user)}
                  style={{
                    padding: '10px 15px',
                    cursor: 'pointer',
                    borderBottom: '1px solid #f0f0f0',
                    transition: 'background-color 0.2s'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                >
                  <div style={{ fontWeight: 'bold', color: '#333' }}>
                    {user.displayName}
                  </div>
                  <small style={{ color: '#666' }}>
                    {user.email}
                  </small>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="filter-actions">
          <button className="btn btn-primary" onClick={resetFilters}>
            Reset Filtri
          </button>
          
          {/* Mostra filtri attivi */}
          {(filters.month || filters.year || filters.status || filters.user) && (
            <div className="active-filters" style={{ 
              marginTop: '10px', 
              fontSize: '14px', 
              color: '#666' 
            }}>
              <strong>Filtri attivi:</strong>
              {filters.month && <span className="filter-tag">Mese: {getMonthName(parseInt(filters.month))}</span>}
              {filters.year && <span className="filter-tag">Anno: {filters.year}</span>}
              {filters.status && <span className="filter-tag">Stato: {filters.status}</span>}
              {filters.user && (
                <span className="filter-tag">
                  Utente: {availableUsers.find(u => u.email === filters.user)?.displayName || filters.user}
                </span>
              )}
            </div>
          )}
        </div>
      </div>
      
      <style jsx>{`
        .admin-filters {
          background: white;
          padding: 20px;
          border-radius: 8px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          margin-bottom: 20px;
        }
        
        .filters-container {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 15px;
          align-items: end;
        }
        
        .filter-group {
          display: flex;
          flex-direction: column;
        }
        
        .filter-group label {
          font-weight: 600;
          margin-bottom: 5px;
          color: #333;
        }
        
        .filter-group select,
        .filter-group input {
          padding: 8px 12px;
          border: 1px solid #ddd;
          border-radius: 4px;
          background: white;
          font-size: 14px;
        }
        
        .filter-group select:focus,
        .filter-group input:focus {
          outline: none;
          border-color: #007bff;
          box-shadow: 0 0 0 2px rgba(0,123,255,0.25);
        }
        
        .filter-actions {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
        }
        
        .btn {
          padding: 8px 16px;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 500;
          transition: all 0.2s ease;
        }
        
        .btn-primary {
          background: #007bff;
          color: white;
        }
        
        .btn-primary:hover {
          background: #0056b3;
        }
        
        .active-filters {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          align-items: center;
        }
        
        .filter-tag {
          background: #e9ecef;
          padding: 4px 8px;
          border-radius: 12px;
          font-size: 12px;
          color: #495057;
          border: 1px solid #dee2e6;
        }
        
        .user-suggestions-dropdown {
          border: 2px solid #007bff !important;
        }
        
        .user-suggestion-item:last-child {
          border-bottom: none;
        }
      `}</style>
    </div>
  );
};

export default AdminFilters;